import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

//import { LoginService } from 'app/components/common/login/login.service';
import { LoginService } from 'app/components/login/login.service';
import { SessionService } from 'app/components/common/session/session.service';
import { CONSTANTS } from 'environments/common';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  displayShowed: boolean = false;

  constructor(private loginService: LoginService,  private router: Router, private sessionService: SessionService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    let url: string = state.url;
    //let userRoles = this.sessionService.get('userRoles') || [];
    //let userEvents = this.sessionService.get('userEvents') || {events: {}, total: 0};
    //let terminal = this.sessionService.get('serialNumber', true) && this.sessionService.get('zoneId', true) && this.sessionService.get('terminalId', true) ? true : false;

    if (this.checkLoggedStatus(url)) {
      // && this.checkUserRoles(userRoles)) {
      return true;
    } else {
      this.loginService.redirectToHome();
      return false;
    }

  }

  checkLoggedStatus(url) {

    if (this.loginService.isAuth()) {
      return true;
    } else {
      return false;

      //this.loginService.redirectUrl = url;
      //this.router.navigate(['/login']);

      //return false;
    }

  }

  checkUserRoles(userRoles) {
    return true;

  //  let validAppRoles = this.sessionService.get('validAppRoles') || [];
  //  let validAppRolesService = this.sessionService.get('validAppRolesService') || false;

  //  if (this.loginService.hasValidRole(userRoles, validAppRoles)) {
  //    return true;
  //  } else {
  //    if (!validAppRolesService) {
  //      this.router.navigate(['/info', 'warning', 'INFO.SERVICE_ERROR']);
  //    } else {
  //      this.router.navigate(['/info', 'warning', 'INFO.INVALID_ROLES']);
  //    }
  //    return false;
  //  }

  }

}
